<template>
	<page-container class="container container-groups no-heading-image" :page="page">
		<content-blocks v-if="page.contentblocks.length" :items="page.contentblocks" />

		<main-content
			:title="(page.title || page.header) ?? 'Page not found'"
			:subtitle="page.subtitle"
			:content="page.content"
			:side-image="{
				image: page.sideImage,
				imageAlt: page.sideImageAlt,
				imageWebp: page.sideImageeWebp,
			}"
		/>

		<div v-if="page.showGroupsForm" class="form-wrapper">
			<div class="row">
				<div class="columns column12">
					<contact-form name="groups" :form="form" />
				</div>
			</div>
		</div>

		<frequently-asked-questions
			v-if="page.frequentlyAskedQuestion"
			:header="page.frequentlyAskedQuestion.header"
			:subtitle="page.frequentlyAskedQuestion.subtitle"
			:items="page.frequentlyAskedQuestion.faqitems"
		/>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { locale } = useI18n();

await fetchPage();

const { data: form } = await useWebsiteFetch('groups', {
	query: { language: locale.value },
	key: `${locale.value}/groups`,
});
</script>

<style lang="scss" scoped>
.form-wrapper {
	.row {
		max-width: 1000px;
		padding: 0 125px;
	}
}

@media (max-width: 1080px) {
	.form-wrapper {
		.row {
			margin-left: auto;
			padding: 0 20px;
		}
	}
}
</style>
